import { Injectable, Inject } from '@angular/core';
import { StorageService } from './storage.service';
import { GenericService } from './generic.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class RequisitionService {

  urlConstants:any = {
    GET_ALL_SOURCE_TYPES: 'api/resume/resumesourcetypes'
  };

  constructor(
    @Inject(StorageService) private StorageService:StorageService, 
    @Inject(GenericService) private genericService: GenericService,
    private authService: AuthService
  ) { }

  getRequisitionActivity(jobId, page, size, successCallback, errorCallback) {
        if(_.isNull(page) || _.isUndefined(page)) {
            page = 1;
        }
        if(_.isNull(size) || _.isUndefined(size)) {
            size = 10;
        }
        let url = this.StorageService.get('baseurl') + this.urlConstants.GET_REQUISITION_ACTIVITY + '/' + jobId + '?page=' + page + '&size=' + size + '&companyId=' + this.authService.getUserDetails().company.companyId;
        this.genericService.addObject(url, {}).subscribe((data) => {
            successCallback(data.body);
        }, (error) => {
            errorCallback(error.error);
        });
    }
}
